import React from 'react';
import styled from 'styled-components/macro';
import Dotdotdot from 'react-dotdotdot';

import ImageElement from 'shared/components/ProductDetailsPageV2/components/ImageElement';
import { Flex } from 'web-ui-kit/containers';
import { black, primaryHighlightM } from 'web-ui-kit/colors';
import { BodySmall, BodySmallBold } from 'shared/fontStyles/StudioHeadings';
import { BodyBoldLargeStyles, BodySmallLargeStyles } from 'web-ui-kit/typography';

export default function CompressedProductDetails ({
  product = null
}) {
  if (!product) { return null; }

  return (
    <Container>
      <ImageContain>
        <ImageElement
          fromAddToCartFeedback
          src={product.firstImageSrc()}
        />
      </ImageContain>

      <InfoContain>
        <InfoTextBold>
          {product.retailer()}
        </InfoTextBold>

        <InfoText isName>
          <Dotdotdot clamp={1}>
            {product.name()}
          </Dotdotdot>
        </InfoText>

        <ProductDetailsPrice
          currentDisplayedPrice={product.currentDisplayedPrice()}
          isDiscounted={product.isDiscounted()}
          regularDisplayedPrice={product.regularDisplayedPrice()}
        />
      </InfoContain>
    </Container>
  );
}

export function ProductDetailsPrice ({
  currentDisplayedPrice = '',
  isDiscounted = false,
  regularDisplayedPrice = ''

}) {
  if (isDiscounted) {
    return (
      <PriceText>
        <InfoText extraMarginBottom strikethrough>
          {regularDisplayedPrice}
        </InfoText>

        <InfoText color={primaryHighlightM} extraMarginBottom>
          {currentDisplayedPrice}
        </InfoText>
      </PriceText>
    );
  }

  return (
    <InfoText>
      {currentDisplayedPrice}
    </InfoText>
  );
}

// Styles
const Container = styled(Flex)`
  flex-direction: row;
  margin-left: 0;
  margin-top: 24px;
  width: 100%;
`;

const ImageContain = styled(Flex)`
  height: 60px;
  width: 60px;
  position: relative;
`;

const InfoContain = styled(Flex)`
  display: inline-block;
  margin-left: 76px;
`;

const PriceText = styled(Flex)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const InfoText = styled(BodySmall)`
  line-height: 14px;
  color: ${black};
  ${BodySmallLargeStyles};
  ${props => props.color && `
    color: ${props.color};
  `}
  margin-bottom: ${props => props.extraMarginBottom ? 8 : 4}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: ${props => props.isName ? 'normal' : 'nowrap'};

  ${props => props.strikethrough &&
    `text-decoration: line-through;`}

`;
InfoText.displayName = 'InfoText';

const InfoTextBold = styled(BodySmallBold)`
  line-height: 14px;
  ${BodyBoldLargeStyles};

  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
InfoTextBold.displayName = 'InfoTextBold';
